module.exports = __webpack_public_path__ + "static/media/IMG_1961.9358e021.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/IMG_1961.jpeg
// module id = 181
// module chunks = 0